module.exports = __webpack_public_path__ + "static/media/semiTractorNoTrailer_turquoise.1974dd40.svg";